import React, {useEffect, useState} from "react";
import {
    TextField,
    Button,
    Typography,
    Container,
    Box,
    CircularProgress,
    Alert,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
} from "@mui/material";
import {getInvoices} from "../../api/axios";

const Refund = () => {
    const [invoiceList, setInvoiceList] = useState([]);
    const [invoiceNumber, setInvoiceNumber] = useState("");
    const [refundStatus, setRefundStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedFromList, setSelectedFromList] = useState("");
    useEffect(() => {
        const fetchInvoices = async () => {
            try {
                const invoices = await getInvoices();
                setInvoiceList(invoices);
                console.log("Dohvaćeni računi:", invoices);
            } catch (error) {
                console.error("Greška prilikom dohvata računa:", error);
                setInvoiceList([]);  // fail-safe
            }
        };

        fetchInvoices();
    }, []);

    const handleRefund = async () => {
        setLoading(true);
        setRefundStatus(null);

        try {
            const response = await fetch("http://localhost:8085/printer/refund", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-API-KEY": "123456",
                },
                body: JSON.stringify({ invoiceNumber }),
            });

            const data = await response.json();

            if (response.ok) {
                setRefundStatus({ type: "success", message: "Refundacija uspešna!" });
                console.log("✅ Refundacija uspešna:", data);
            } else {
                setRefundStatus({ type: "error", message: "Refundacija neuspešna!" });
                console.error("❌ Refundacija neuspešna:", data);
            }
        } catch (err) {
            setRefundStatus({ type: "error", message: "Greška prilikom refundacije!" });
            console.error("Greška refundacije:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSelectInvoice = (e) => {
        const selectedValue = e.target.value;
        setSelectedFromList(selectedValue);
        setInvoiceNumber(selectedValue); // automatski postavlja i u input
    };

    return (
        <Container maxWidth="sm" sx={{ mt: 5 }}>
            <Typography variant="h4" gutterBottom align="center">
                Refundacija
            </Typography>

            <Box display="flex" flexDirection="column" gap={3}>
                <TextField
                    label="Broj fiskalnog računa"
                    variant="outlined"
                    fullWidth
                    value={invoiceNumber}
                    onChange={(e) => setInvoiceNumber(e.target.value)}
                    disabled={loading}
                />

                <FormControl fullWidth>
                    <InputLabel id="select-invoice-label">Izaberi iz liste</InputLabel>
                    <Select
                        labelId="select-invoice-label"
                        value={selectedFromList}
                        label="Izaberi iz liste"
                        onChange={handleSelectInvoice}
                        disabled={loading}
                    >
                        {invoiceList.map((inv) => (
                            <MenuItem key={inv} value={inv}>
                                {inv}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <Button
                    variant="contained"
                    color="primary"
                    disabled={!invoiceNumber || loading}
                    onClick={handleRefund}
                >
                    {loading ? <CircularProgress size={24} /> : "Refundiraj"}
                </Button>

                {refundStatus && (
                    <Alert severity={refundStatus.type} onClose={() => setRefundStatus(null)}>
                        {refundStatus.message}
                    </Alert>
                )}
            </Box>
        </Container>
    );
};

export default Refund;
